/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react';

const Warning = ({ warningText, actionConfirm, actionDeny }) => {
    const el = useRef(null);

    useEffect(() => {
        if (el?.current) {
            el.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    return (
        <div ref={el} className="overlay-warning">
            <span className="symbol">Warning symbol</span>
            <div className="text">{warningText}</div>
            {actionDeny && (
                <button className="cancel-button" onClick={actionDeny}>
                    <span className="vh">Cancel</span>
                </button>
            )}
            <button className="btn button span confirm-button" onClick={actionConfirm}>
                <span>Confirm</span>
            </button>
        </div>
    );
};

export default Warning;
